import type { HelpFile } from '../../types/help'
import { PageSpinnerTestIds } from '../../../testids/PageSpinnerTestIds'

export const pageSpinnerHelp: HelpFile = {
  docPage: '/docs/help-system/components',
  texts: {
    [PageSpinnerTestIds.pageSpinner]: null,
  },
}
